export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'application/pdf'];
export const MAX_FILE_SIZE_MB = 10;
export const MAX_QUANTITY = 10;